// extracted by mini-css-extract-plugin
export default {"table":"transformDataToPrintTable_table__uLqH2"};